<cx-storefront></cx-storefront>

<ng-template cxOutletRef="cx-header" cxOutletPos="before">
  <cx-page-layout section="announcement-banner">
    <cx-page-slot position="AnnouncementBanner"></cx-page-slot>
  </cx-page-layout>
</ng-template>
